


































import { defineComponent } from '@nuxtjs/composition-api'
import { temiCaldiLink } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    props: {
        classes: {
            type: Object,
            default: () => { return {} }
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        imageSrc: {
            type: String
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup() {
        const trackTemiCaldiLink = () => temiCaldiLink();
        return {
            trackTemiCaldiLink
        }
    },
})
